import './global.css';
import { APIRequestStatus } from 'common-ts/dist/models/APIRequestStatus';
import React, { useEffect } from 'react';
import { socket } from './socket';
import {
  BrowserRouter as Router, Route, Switch, useHistory, useLocation, withRouter, Redirect
} from 'react-router-dom';

import { Box, createTheme, Fab, Toolbar, TextField, Typography, useMediaQuery, Grid, Button, Dialog, Slide } from '@material-ui/core';
import { createStyles, makeStyles, Theme, ThemeProvider, useTheme } from '@material-ui/core/styles';
import CommentIcon from '@material-ui/icons/Comment';
import { TransitionProps } from '@material-ui/core/transitions';

import { Player } from '@lottiefiles/react-lottie-player';
import axios, { AxiosRequestConfig } from 'axios';
import VolumeOffIcon from '@material-ui/icons/VolumeOff';
import VolumeUpIcon from '@material-ui/icons/VolumeUp';
import NavBar from './components/NavBar';
import OverlayViewAccount from './components/OverlayViewAccount';
import OverlayViewAddress from './components/OverlayViewAddress';
import OverlayViewMeasurementSelection from './components/OverlayViewMeasurementSelection';
import OverlayViewPopupFlowVersion from './components/OverlayViewPopupFlowVersion';
import OverlayViewPopupOngkir from './components/OverlayViewPopupOngkir';
import OverlayViewPopupLivestreamIntro from './components/OverlayViewPopupLivestreamIntro';
import OverlayViewMeasurementMethodSelection from './components/OverlayViewMeasurementMethodSelection';
import PageAccount from './components/PageAccount';
import PageCheckout from './components/PageCheckout';
import PageHomeCommerce from './components/PageHomeCommerce';
import PageHomeFooter from './components/PageHome7Footer';
import PageOrderCommerce from './components/PageOrderCommerce';
import PageCustomCommerce from './components/PageCustomCommerce';
import PagePreviewBlocks from './components/PagePreviewBlocks';
import PageLinkPage from './components/PageLinkPage';
import PageShopkeeperPanel from './components/PageShopkeeperPanel';
import PageProduct from './components/PageProduct';
import LiveStream from './components/LiveStream';
import { terbebasClient, TERBEBAS_STORE_SLUG } from './terbebasApi';
import { Mixpanel } from './mixpanel';
import { AccountState, getChatHistory, updateState, newChatMessage } from './redux/AccountRedux';
import { fetchAddresses } from './redux/AddressRedux';
import { getCurrentShipmentPromo, postCheckCurrentCartAvailability, setProductSpotlightList, submitCouponRequest } from './redux/CartRedux';
import { uploadLocalUnsavedMeasAndSynchronize } from './redux/MeasurementsRedux';
import { fetchOrdersList } from './redux/OrdersListRedux';
import { fetchProductsList } from './redux/ProductsListRedux';
import { fetchStoreProfile } from './redux/StoreProfileRedux';
import {
  FlowVersionState, loadFlowVersionState, openOverlayGeneralIntro, setCollectionQueryKey, setFlowVersion, setSortQueryKey
} from './redux/UIOverlayFlowVersionRedux';
import { openOverlay } from './redux/UIOverlayOngkirRedux';
import { useAppDispatch, useAppSelector } from './reduxhooks';
import { sendWebsiteEventMessage, sendWebsiteLivestreamMessage, setUserIdentifier } from './telegrambotevents';

import {
  Stage,
  LocalStageStream,
  SubscribeType,
  StageEvents,
  ConnectionState,
  StageConnectionState,
  StreamType
} from 'amazon-ivs-web-broadcast';
import Draggable from 'react-draggable'; // Import react-draggable
import Countdown from 'react-countdown';
import { ProductSpotlight } from 'common-ts/dist/models/Cart';
import { fetchCategoryReviewRecap } from './redux/CategoryReviewRedux';
import { sendLivestreamMessage, sendLivestreamStatus, setLivestreamDialog, setMiniMuteStatus, setSenderObject, setStreamIsOn, updateOfflineLiveState } from './redux/LivestreamRedux';
import { IframeMessageBridge } from './components/IframeCartSync';
import AnalyticsRouteTracker from './components/AnalyticsRouteTracker';

const theme = createTheme({
  palette: {
    primary: {
      light: '#e2f1f8',
      main: '#484848',
      dark: '#808e95',
      contrastText: '#fff',
    },
  },
  typography: {
    fontFamily: [
      'OakesGrotesk',
      'sans-serif'
    ].join(','),
  },
});

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    contentRoot: {
      // margin: '20px',
      backgroundColor: '#fff',
      height: '100%',
    },
    overlayView: {
    },
    chatIconTailor: {
      width: '24vw',
      zIndex: 1300,
      position: 'fixed',
      left: '30px',
      bottom: '-4px',
      '-webkit-tap-highlight-color': 'transparent',
      [theme.breakpoints.down('xs')]: {
        left: '12px',
        width: '76vw',
        bottom: '-4px',
      }
    },
    chatIcon: {
      width: '7vw',
      zIndex: 1300,
      position: 'fixed',
      right: '20px',
      bottom: '26px',
      '-webkit-tap-highlight-color': 'transparent',
      [theme.breakpoints.down('xs')]: {
        right: '4vw',
        bottom: '6vw',
        width: '21vw',
      },
    },
    promoIcon: {
      width: '8vw',
      zIndex: 1300,
      position: 'fixed',
      left: '13px',
      bottom: '20px',
      '-webkit-tap-highlight-color': 'transparent',
      [theme.breakpoints.down('xs')]: {
        left: '3vw',
        bottom: '5vw',
        width: '21vw',
      },
    },
    promoIconSvg: {
      '-webkit-tap-highlight-color': 'transparent',
      paddingLeft: '0px',
      width: '100%',
      marginBottom: '0px'
    },
    personalSizeIconSvgLocked: {
      width: '87%',
      paddingLeft: '4px',
      paddingBottom: "10px",
      '-webkit-tap-highlight-color': 'transparent',
    },
    personalSizeIconSvg: {
      width: '84%',
      paddingLeft: '7px',
      paddingBottom: "10px",
      '-webkit-tap-highlight-color': 'transparent',
      cursor: 'pointer',
    },
    chatIconSvgTailor: {
      width: '80%',
      paddingLeft: '10px',
      marginBottom: '0',
      '-webkit-tap-highlight-color': 'transparent',
      borderRadius: '7% 7% 0 0',
    },
    chatIconSvg: {
      width: '95%',
      paddingLeft: '10px',
      marginBottom: '-16px',
      '-webkit-tap-highlight-color': 'transparent',
    },
    chatIconSpacer: {
      width: '24vw',
      minHeight: '28vw', // Estimated height needed
      [theme.breakpoints.down('xs')]: {
        width: '50vw',
        minHeight: '80vw', // Estimated height needed
      }
    },
    commentIcon: {
      marginRight: '10px',
    },
    bannerOngkir: {
      width: "100%",
      // marginLeft: "-6px",
      minHeight: "36px",
      backgroundColor: "#2A2A2A",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    bannerOngkirText: {
      color: "#ffffff",
      fontSize: "9px",
      height: "9px",
      letterSpacing: "1px",
      fontWeight: 300,
    },
    bannerOngkirTextLink: {
      paddingLeft: "4px",
      textUnderlineOffset: "3px",
      textDecorationThickness: "0.8px",
      textDecorationLine: "underline",
      cursor: "pointer",
      WebkitTapHighlightColor: "transparent",
    },
    dialogSendMessageLivestream: {
      '& .MuiDialog-container': {
        overflowY: 'scroll',
      },
      '& .MuiPaper-root': {
        borderRadius: '31px',
        maxHeight: '2000px',
        marginTop: '320px',
        marginBottom: '80px',
      }
    },
  }),
);

function ScrollToTop({ history }: any) {
  const dispatch = useAppDispatch();
  useEffect(() => {
    const unlisten = history.listen(() => {
      const text1 = "UD-Masuk Ke " + window.location.href;
      sendWebsiteEventMessage(text1);
      // Page change: update the presence roster (not the public chat).
      dispatch(sendLivestreamStatus());
      if (window.location.href.includes("/shop")) {
        // if (window.location.href.includes("/shop/product")) {
        //   .send(JSON.stringify({
        //     "Action": "SEND_MESSAGE",
        //     "Content": "Masuk Ke Produk " + window.location.href,
        //   }));
        // }
        // setTimeout(() => {
        //   window.scrollTo({ top: 0, behavior: 'smooth' });
        // }, 350); 
        // Give 0.35s delay, for rendering to take place
      } else {
        // window.scrollTo({ top: 0, behavior: 'smooth'});
        setTimeout(() => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 350); 
        // Give 0.35s delay, for rendering to take place
      }
    });
    return () => {
      unlisten();
    }
  }, []);

  return (null);
}

const ScrollToTopComponent = withRouter(ScrollToTop);

export function BantuanSpacer() {
  const classes = useStyles();
  return (
    <Box className={classes.chatIconSpacer}>
    </Box>
  )
}

interface BantuanProps {
  hideBantuan: boolean
  useTailor: boolean
}

// WhatsApp contact float. Shows only when the merchant configured a
// WhatsApp number in StoreConfig.contact.whatsapp (e.g. "6281234567890").
export function Bantuan({ useTailor, hideBantuan }: BantuanProps) {
  const classes = useStyles();
  const whatsapp = useAppSelector(state =>
    ((state.storeProfile.profile?.config?.contact as any)?.whatsapp ?? '') as string);

  if (hideBantuan || !whatsapp) {
    return null;
  }

  const waHref = 'https://wa.me/' + whatsapp.replace(/[^0-9]/g, '')
    + '?text=' + encodeURIComponent('Halo kak, saya mau tanya tentang produk di toko kamu.');

  return (
    <Box className={classes.chatIcon}
      onClick={() => {
        if ((window as any).fbq !== null) {
          (window as any).fbq('track', 'Contact');
        }
        Mixpanel.track('contactStoreWhatsapp');
      }} key={"wa-box-thumbnail"}>
      <a href={waHref} target="_blank" rel="noreferrer">
        <img src={"https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"}
        alt={"wa-thumbnail"}
        onClick={
          () => {
            sendWebsiteEventMessage("User buka tombol WA");
          }
        } className={classes.chatIconSvg} />
      </a>
    </Box>
  )
}

const countdownRendererPromoIcon = (color: string) => {
  return (({ hours, minutes, seconds, completed }: any) => {
    // const classes = useStyles();

    if (completed) {
      return (
      <div/>);
    } else {
      return (
      <Box style={{
        containerType: 'inline-size',
        margin: '-36cqw 0px 0px 0px',
        padding: '0px 0px 0px 0px',
        color: color,
        width: '100%',
        textAlign: 'center',
      }}>
        <Typography style={{
          fontSize: '14cqw',
          fontFamily: 'OakesGrotesk',
          fontWeight: 500,
        }}>{String(hours).padStart(2, '0')}:{String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}</Typography>
      </Box>)
    }
  })
};


interface PromoFloatProps {
}

export function PromoFloat({}: PromoFloatProps) {
  const theme = useTheme();
  const couponObj = useAppSelector(state => state.cart.coupon);
  // const userIsSignedInAndHasPurchasedOnce = useAppSelector(state => state.account.authState === 'signedin' && state.ordersList.paidOrderCount === 1);
  const isMdOrUp = useMediaQuery(theme.breakpoints.up("sm"));
  const classes = useStyles();
  const dispatch = useAppDispatch();

  // TODO-PROMO Add for WA PROMO
  // Coupon based

  if ((couponObj?.couponKey?.startsWith("REPURCHASE") || couponObj?.couponKey?.startsWith("AJAKTEMEN")) && new Date().toISOString() < couponObj.expirationDateTime) {

    return (
      <Box className={classes.promoIcon}
        onClick={() => {
          // Promo overlay removed (QR repurchase flow dropped).
        }} key={"promo-box-thumbnail"}>
        <Box style={{
          position: 'relative',
          width: '100%',
          containerType: 'inline-size',
        }}>
        <img src={couponObj?.couponKey?.startsWith("REPURCHASE") ? 
        "https://studiosclo.uk/general/icon-promo-20-countdown-red.png" : 
        "https://studiosclo.uk/general/icon-promo-20-countdown.png"} alt={"promo-thumbnail"}
        className={classes.promoIconSvg}/>
        <Countdown
          date={couponObj.expirationDateTime}
          renderer={countdownRendererPromoIcon(couponObj?.couponKey?.startsWith("REPURCHASE") ? '#ffffff' : '#121212')}
          onComplete={(timeDelta, completedOnStart) => {
          }}
        />
        </Box>
      </Box>
    )
  } else if (couponObj?.couponCountdownMedia && new Date().toISOString() < couponObj.expirationDateTime) {

    // We assume the countdown media is png for now
    if (couponObj.couponCountdownMedia.includes('.png')) {
      return (
        <Box className={classes.promoIcon}
          onClick={() => {
            // Promo overlay removed (QR repurchase flow dropped).
          }} key={"promo-box-thumbnail"}>
          <Box style={{
            position: 'relative',
            width: '100%',
            containerType: 'inline-size',
          }}>
          <img src={couponObj.couponCountdownMedia} alt={"promo-thumbnail"}
          className={classes.promoIconSvg}/>
          <Countdown
            date={couponObj.expirationDateTime}
            renderer={countdownRendererPromoIcon('#ffffff')}
            onComplete={(timeDelta, completedOnStart) => {
            }}
          />
          </Box>
        </Box>
      )
    }
  }

  return null;
}

// Announcement bar: shows StoreConfig.theme.announcementText when the
// merchant sets one (replaces the hardcoded fareast free-ongkir strip).
export function BannerOngkir({ hideView }: { hideView?: boolean }) {
  const classes = useStyles();
  const announcementText = useAppSelector(state =>
    ((state.storeProfile.profile?.config?.theme as any)?.announcementText ?? '') as string);

  if (!announcementText) {
    return null;
  }

  return (
    <Box className={classes.bannerOngkir} style={{visibility: hideView ? 'hidden' : 'visible'}}>
      <Typography className={classes.bannerOngkirText}>
        {announcementText}
      </Typography>
    </Box>
  )
}


const imageLottieDict: {[key: string]: string} = {
  "konsultasiSize": "https://studiosclo.uk/general/Lottie_Jahit.json",
  "dokterKain": "https://studiosclo.uk/general/Lottie_Delivery.json",
};
const imageLottieDictStyle: {[key: string]: any} = {
  "konsultasiSize": {
    height: '110px',
    position: "absolute",
    bottom: '-6px',
    left: 'calc(50% - 56px)',
  },
  "konsultasiSizeMobile": {
    height: '16vw', // 25h to 13w
    position: "absolute",
    bottom: '2px',
    left: 'calc(50% - 9vw)',
  },
  "konsultasiSizeMobileFull": {
    height: '14vw', // 25h to 13w
    position: "absolute",
    bottom: '2px',
    left: 'calc(50% - 9vw)',
  },
  "dokterKain": {
    height: '130px',
    position: "absolute",
    bottom: '-16px',
    left: 'calc(50% - 64px)',
  },
  "dokterKainMobile": {
    height: '20vw', // 25h to 13w
    position: "absolute",
    bottom: '-8px',
    left: 'calc(50% - 11vw)',
  },
  "dokterKainMobileFull": {
    height: '18vw', // 25h to 13w
    position: "absolute",
    bottom: '-8px',
    left: 'calc(50% - 11vw)',
  },
};
const imageLottieTitle: {[key: string]: string} = {
  "konsultasiSize": "KONSULTASI SIZE",
  "dokterKain": "DOKTER KAIN",
};
const imageLottieDescription: {[key: string]: string} = {
  "konsultasiSize": "Konsultasi, dan kita buatkan size, live! Bisa langsung dipakai dalam website.",
  "dokterKain": "Katanya kalau kain polyester itu pasti selalu jelek... apakah benar? Kita bahas.",
};

export const videoMainStreamId = 'mainstream';

// SRS media server HTTP base (serves /rtc/v1/whep). Stream name = store
// slug, so one media server hosts every tenant's live feed. Defaults match
// a local `ossrs/srs` docker dev setup.
export const SRS_HTTP_URL = process.env.REACT_APP_SRS_HTTP_URL ?? 'http://localhost:1985';


// Small Stream Popup
const FloatingLiveStream = ({ isOpen, openSendMessage, stageInfo }: 
  { isOpen: boolean, openSendMessage: () => void, stageInfo: any }) => {
  const [kirimText, setKirimText] = React.useState('');
  const isMdOrUp = useMediaQuery(theme.breakpoints.up("sm"));
  const isMuted = useAppSelector(state => state.livestreamState.miniMuteStatus === 'MUTED');
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!(window.location.href?.includes("shopkeeper-panel"))) {
      if (isOpen) {
        dispatch(setLivestreamDialog('MINI'));
        dispatch(setMiniMuteStatus(isMuted ? 'MUTED' : 'ACTIVE'));
        // Mute/open state rides the presence roster, not the public chat.
        dispatch(sendLivestreamStatus());
        dispatch(sendLivestreamStatus());
      }
    }
    const videoEl: any = document.getElementById(videoMainStreamId);
    if (videoEl) {
      videoEl.muted = !(isOpen && !isMuted);
      if (isOpen) {
        videoEl.play().catch(() => {}); // autoplay races with pause on quick toggles
      } else {
        videoEl.pause();
      }
    }
  }, [isOpen, isMuted]);

  return (
    <Draggable cancel="#mute-button-livestream, #tanya-live-container, #remote-media">
      <div style={{
        display: isOpen ? 'block' : 'none',
        position: 'fixed',
        bottom: '20px',
        left: '20px',
        backgroundColor: '#fff',
        border: '1px solid #ccc',
        borderRadius: isMdOrUp ? '30px' : '21px',
        padding: isMdOrUp ? '12px' : '5px',
        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.2)',
        zIndex: 1300, /* Adjust the z-index to ensure it appears above other content */
      }}
      >
        {/* {
          stageInfo?.event === "dokterKain" || stageInfo?.event === "konsultasiSize" ?
          <Box style={{
            height: '18px',
            position: 'relative',
          }}>
            <Player
              key='regular-animation'
              autoplay
              loop
              src={imageLottieDict[stageInfo.event as string]}
              style={imageLottieDictStyle[(stageInfo.event as string) + (isMdOrUp ? "" : "Mobile")]}
            />
          </Box>:
          null
        } */}
        <div id='remote-media-container' style={{
          position: 'relative',
          minWidth: '90px',
          minHeight: '100px',
        }}
        >
          {
            isMuted ? 
            <div style={{
              position: "absolute",
              top: "6px",
              right: "6px",
              color: "#ffffff",
              backgroundColor: "#232323",
              padding: "6px 4px 4px 6px",
              width: '20px',
              height: '20px',
              borderRadius: "18px",
              zIndex: 1000,
            }}
            id='mute-button-livestream'
            onClick={() => {
              dispatch(setMiniMuteStatus('ACTIVE'));
              sendWebsiteEventMessage('[LIVE] Click UNMUTE audio (mini).');
            }}>
              <VolumeOffIcon style={{
                fontSize: '17px'
              }}/>
            </div>:
            <div style={{
              position: "absolute",
              top: "6px",
              right: "6px",
              color: "#ffffff",
              backgroundColor: "#232323",
              padding: "6px 4px 4px 6px",
              width: '20px',
              height: '20px',
              borderRadius: "18px",
              zIndex: 1000,
            }}
            id='mute-button-livestream'
            onClick={() => {
              dispatch(setMiniMuteStatus('MUTED'));
              sendWebsiteEventMessage('[LIVE] Click MUTE audio (mini).');
            }}>
              <VolumeUpIcon style={{
                fontSize: '17px'
              }}/>
            </div>
          }
          <div id='remote-media' style={{
            position: 'relative',
          }}
          onClick={() => {
            dispatch(setMiniMuteStatus('ACTIVE'));
  
            openSendMessage();
            sendWebsiteEventMessage('[LIVE] Click OPEN full screen livestream.');
          }} >
            <div id={videoMainStreamId + '-container'}>
              <video id={videoMainStreamId} style={{width: '100%', borderRadius: '18px', maxWidth: '30vw', maxHeight: '50vh'}} autoPlay muted playsInline
              onPause={() => {
                const videoEl: any = document.getElementById(videoMainStreamId);
                if (videoEl && isOpen) {
                  // videoEl.play();
                }
              }}/>
            </div>
          </div>
          {/* <div style={{
            position: "absolute",
            bottom: "6px",
            left: "6px",
            color: "#ffffff",
            backgroundColor: "#232323",
            padding: "6px 4px 4px 6px",
            width: '20px',
            height: '20px',
            borderRadius: "18px",
            zIndex: 1000,
          }}
          id='mute-button-livestream'
          onClick={() => {
          }}>
            <Typography>{Object.values(lsParticipantsDict).filter(item => item === true).length}</Typography>
          </div> */}
        </div>
        {
          isMdOrUp ?
          <Grid container style={{
            maxWidth: '28vh', // Pairs to maximum height of 9 / 16 of 50vh (50vh * 9 / 16)
            padding: '4px 2px 7px 8px',
          }}>
            <Grid item xs={9}>
              <TextField
                margin="dense"
                fullWidth
                id="livestreamChatInput"
                name="livestreamChatInput"
                label="Tanya Disini"
                type="text"
                value={kirimText}
                error={false}
                onChange={(e) => {
                  setKirimText(e.target?.value);
                }}
                InputLabelProps={{
                  shrink: true,
                }}/>
            </Grid>
            <Grid item xs={3} style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
              borderRadius: '20px',
            }}>
              <Button onClick={() => {
                if (kirimText !== '') {
                  sendWebsiteEventMessage('[LIVE] Message: ' + kirimText);
                  dispatch(sendLivestreamMessage(kirimText));
                }
                setKirimText('');
              }} style={{
                backgroundColor: '#232323',
                color: '#ffffff',
                fontWeight: 400,
                letterSpacing: '0.9px',
                fontSize: '10px',
                padding: '4px 9px 1px 9px',
                borderRadius: '12px',
                minWidth: '4px',
              }}>
                KIRIM
              </Button>
            </Grid>
          </Grid>:
          <Grid container onClick={() => {
            dispatch(setMiniMuteStatus('ACTIVE'));

            openSendMessage();
            sendWebsiteEventMessage('[LIVE] Click OPEN full screen livestream.');
          }} id='tanya-live-container'>
            <Grid item xs={6} style={{
              position: 'relative',
            }}>
              <Typography style={{
                fontSize: '8px',
                fontWeight: 600,
                letterSpacing: '0.6px',
                margin: '6px 4px 4px 5px',
                padding: '3px 3px 1px 8px',
                borderRadius: '10px',
                backgroundColor: '#232323',
                color: '#ffffff',
                textAlign: 'left',
              }}>
                LIVE
              </Typography>
              <div style={{
                position: 'absolute',
                right: '9px',
                top: '9.7px',
                borderRadius: '10px',
                width: '8px',
                height: '8px',
                color: 'red',
                backgroundColor: 'red',
              }}></div>
            </Grid>
            <Grid item xs={6}>
              <Typography style={{
                fontSize: '8px',
                fontWeight: 500,
                letterSpacing: '0.6px',
                margin: '6px 6px 5px 6px',
                padding: '2.5px 3px 0.5px 4px',
                borderRadius: '10px',
                border: '0.5px solid #a0a0a0',
                textAlign: 'center',
              }}>
                BUKA
              </Typography>
            </Grid>
          </Grid>
        }
      </div>
    </Draggable>
  );
};


const countdownRenderer = ({ hours, minutes, seconds, completed }: any) => {
  // const classes = useStyles();

  if (completed) {
    return (
    <div/>);
  } else {
    return (
    <Box style={{
      margin: '7px 0px 5px 0px',
      padding: '2px 6px 1px 6px',
      borderRadius: '20px',
      color: '#ffffff',
      backgroundColor: '#121212',
    }}>
      <Typography style={{
        fontSize: '9px',
        fontFamily: 'OakesGrotesk',
        fontWeight: 400,
      }}>{String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}</Typography>
    </Box>)
  }
};

export function changeFileDataSource(fileUrl: string): string {
  const resultString = fileUrl
  .replaceAll("https://images-far-east.s3.ap-southeast-1.amazonaws.com/", "https://studiosclo.uk/legacy/")
  .replaceAll("https://d31zz7s33c4k72.cloudfront.net/", "https://studiosclo.uk/legacy/")
  .replaceAll("https://files-far-east.s3.ap-southeast-1.amazonaws.com/", "https://studiosclo.uk/");
  return resultString;
}

// Main Stream Popup
const DialogSendMessageLivestream = ({isOpen, setLsDialogSendMessageOpen, lsParticipantId, stageInfo }: 
  {isOpen: boolean, setLsDialogSendMessageOpen: (nextState: boolean) => void, lsParticipantId: string, stageInfo: any}) => {
  const classes = useStyles();
  const isMdOrUp = useMediaQuery(theme.breakpoints.up("sm"));
  const history = useHistory();
  const [lsKirimText, setLsKirimText] = React.useState('');
  const productsDictionary = useAppSelector((state) => state.productsList.productsDictionary);
  const productSizeAvailabilityDict = useAppSelector(state => state.productsList.productSizeAvailabilityDict);
  const productSpotlightList = useAppSelector(state => state.cart.productSpotlightList);
  const dispatch = useAppDispatch();
  
  const [lastRenderTime, setLastRenderTime] = React.useState<string>('');
  const [productSpotlight, setProductSpotlight] = React.useState<ProductSpotlight | null>(null);

  useEffect(() => {
    const findProductSpotlight = () => {
      const currentTime = new Date().toISOString() 
      const foundSpotlight = productSpotlightList.find(spotlight => (spotlight.isMainSpotlight && (currentTime < spotlight.timestampLimit) && (currentTime > spotlight.timestampStart)));
      console.log('FOUND: ' + JSON.stringify(foundSpotlight));
      return foundSpotlight ? foundSpotlight : null;
    };

    const spotlight = findProductSpotlight();
    setProductSpotlight(spotlight);
  }, [productSpotlightList]);

  useEffect(() => {
    if (!(window.location.href?.includes("shopkeeper-panel"))) {
      if (isOpen) {
        dispatch(setLivestreamDialog('LIVE'));
        dispatch(sendLivestreamStatus());
      }
    }
    const videoEl: any = document.getElementById(videoMainStreamId + '-full');
    if (videoEl) {
      videoEl.muted = isOpen ? false : true;
      if (isOpen) {
        videoEl.play().catch(() => {}); // autoplay races with pause on quick toggles
      } else {
        videoEl.pause();
      }
    }
  }, [isOpen]);

  
  // console.log(productSpotlight)

  let product = null
  let productOriginalPrice = 0
  let productName = ''
  let productRemaining = 0
  let productDisplayImage = ''
  let productDiscount = 0
  let chatMargin = '7px'

  if (productSpotlight) {
    product = productsDictionary[productSpotlight.productId];
    productOriginalPrice = product?.originalPrice ? product.originalPrice : 100000;
    productName = product?.name ? product.name : "Product Name";
    productRemaining = productSizeAvailabilityDict?.[productSpotlight.productId]?.numberOfItemsRemaining ?? 0;
    productDisplayImage = product?.displayImage ? product.displayImage : "display_image_url";
    productDiscount = Math.floor( (1 - (productSpotlight.discountedPrice / productOriginalPrice)) * 100 );
    chatMargin = '30%'
  }

  return (
    <Dialog
    open={isOpen}
    TransitionComponent={Transition}
    keepMounted
    aria-labelledby="alert-dialog-slide-title"
    aria-describedby="alert-dialog-slide-description"
    onClose={() => {
      setLsDialogSendMessageOpen(false);
      sendWebsiteEventMessage('[LIVE] Click CLOSE full screen livestream.');
    }} className={classes.dialogSendMessageLivestream}>
      <Grid container style={{
        padding: '20px 11px 21px',
        // padding: stageInfo?.event ? '20px 11px 21px' : '27px 11px 21px',
      }}>
        {/* {
          stageInfo?.event === "dokterKain" || stageInfo?.event === "konsultasiSize" ?
          <>
            <Grid item xs={5} style={{
              height: '52px',
              position: 'relative',
            }}>
              <Player
                key='regular-animation'
                autoplay
                loop
                src={imageLottieDict[stageInfo.event as string]}
                style={imageLottieDictStyle[(stageInfo.event as string) + "MobileFull"]}
              />
            </Grid>
            <Grid item xs={7} style={{
              height: '59px',
            }}>
              <Typography style={{
                marginRight: '2px',
                marginBottom: '2px',
                fontSize: '77%',
                fontWeight: 600,
                letterSpacing: '0.07vw',
              }}>
                {imageLottieTitle[stageInfo.event as string]}
              </Typography>
              <Typography style={{
                marginRight: '18px',
                fontSize: '1.8vw',
                fontWeight: 300,
                color: '#5f5f5f',
                letterSpacing: '0.03vw',
              }}>
                {imageLottieDescription[stageInfo.event as string]}
              </Typography>
            </Grid>
          </>:
          null
        } */}
        <Grid item xs={12} style={{
          marginBottom: '6px'
        }}>
          <div id='remote-media-full'>
            <div 
              id={videoMainStreamId + '-container-full'}
              style={{
                position: 'relative',
              }}
            >
              <video id={videoMainStreamId + '-full'} style={{width: '100%', borderRadius: '18px'}} autoPlay muted playsInline
              onPause={() => {
                const videoEl: any = document.getElementById(videoMainStreamId + '-full');
                if (videoEl && isOpen) {
                  // videoEl.play();
                }
              }}/>
              {/* Catatan: ini chatnya susah dibaca */}
              <Box
                style={{
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  right: 0,
                  padding: theme.spacing(2),
                  background:
                    "linear-gradient(to top, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0) 100%)",
                  color: "white",
                  height: "50%",
                  zIndex: 1300,
                  pointerEvents: "none",
                  borderRadius: 20
                }}
              />
              <div 
                id="chat-ws-logs" 
                style={{
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  right: 0,
                  display: 'inline-flex',
                  flexDirection: 'column',
                  justifyContent: 'flex-end',
                  padding: '0px 16px 4px',
                  pointerEvents: 'none',
                  marginBottom: chatMargin,
                  overflowY: 'scroll',
                  height: '200px',
                  borderRadius: '10px',
                  color: 'white',
                  zIndex: 1500,
                  '--mask': `linear-gradient(to top, 
                    rgba(0,0,0, 1) 0,   rgba(0,0,0, 1) 40%, 
                    rgba(0,0,0, 0) 95%, rgba(0,0,0, 0) 0
                  ) 100% 50% / 100% 100% repeat-x`,
                  WebkitMask: 'var(--mask)',
                  mask: 'var(--mask)',
                } as React.CSSProperties}>
              </div>
              {
                productSpotlight &&
                <Box
                  style={{
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    right: 0,
                    padding: '4%',
                    color: "#121212",
                    width: '100%',
                    zIndex: 1700,
                    // pointerEvents: "none",
                    boxSizing: 'border-box',
                    aspectRatio: '3'
                  }}
                >
                  {/* Container */}
                  <Box
                    onClick={() => {
                      if (productSpotlight?.productId) {
                        history.push('/shop/product/' + productSpotlight.productId);
                        setLsDialogSendMessageOpen(false);
                        sendWebsiteEventMessage('[LIVE] Click CLOSE full screen livestream.');
                      }
                    }}
                    style={{
                      display: 'flex',
                      flexBasis: '100%',
                      width: '100%',
                      height: '100%',
                      background: 'white',
                      borderRadius: 10
                    }}
                  >
                    {/* Image */}
                    <Box
                      style={{
                        height: '100%',
                        objectFit: 'contain',
                        aspectRatio: 'calc(2/3)'
                      }}
                    >
                      <img src={productDisplayImage} style={{height: '100%', width: '100%', borderTopLeftRadius: 10, borderBottomLeftRadius: 10}}/>
                    </Box>

                    {/* Content */}
                    <Box
                      style={{
                        display: 'flex',
                        flex: 1,
                        flexDirection: 'row',
                        height: '100%',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        position: 'relative',
                      }}
                    >
                      {/* Left side */}
                      <Box
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'space-between',
                          alignItems: 'flex-start',
                          height: '100%',
                          padding: '0px 0px 0px 7px',
                        }}
                      >
                        {

                        }
                        {/* Timer */}
                        <Countdown
                          date={productSpotlight?.timestampLimit}
                          renderer={countdownRenderer}
                          onComplete={(timeDelta, completedOnStart) => {
                            setTimeout(() => {
                              setLastRenderTime(new Date().toISOString())
                            }, 400)
                          }}
                        />
        
                        <Typography style={{
                          marginTop: '2px',
                          marginBottom: '4px',
                          fontWeight: 500,
                          fontSize: '13px',
                          fontFamily: 'OakesGrotesk',
                        }}>
                          {productName}
                        </Typography>

                        {/* Sisa */}
                        {/* <Box>
                        {
                          productRemaining && productRemaining < 14 ?
                            <Box className={classes.sisaBox}>
                              <Typography className={classes.sisaText}>
                                Sisa {productRemaining} pcs
                              </Typography>
                            </Box> :
                            null
                        }
                        </Box> */}

                        {/* Harga */}
                        <Box
                          style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'flex-start',
                            alignItems: 'center',
                            marginBottom: '10px',
                          }}
                        >
                          <Typography style={{
                            fontSize: '9px',
                            fontWeight: 400,
                          }}>
                            Rp {productSpotlight?.discountedPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " "}
                          </Typography>
                          <Typography style={{
                            color: 'red',
                            fontSize: '7px',
                            fontWeight: 400,
                            textDecoration: 'line-through',
                            marginLeft: '5px',
                          }}>
                            Rp {productOriginalPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " "}
                          </Typography>
                          <Box style={{
                            marginLeft: '6px',
                            padding: '2px 4px 1px 4px',
                            backgroundColor: 'red',
                            color: 'white',
                            borderRadius: '20px',
                          }}>
                            <Typography style={{
                              fontSize: '7px',
                              letterSpacing: '0.3px',
                            }}>
                              -{productDiscount}%
                            </Typography>
                          </Box>
                        </Box>
                      </Box>

                      {/* Right side */}
                      <Box style={{
                        position: 'absolute',
                        right: '6px',
                        bottom: '6px',
                        padding: '4px 9px 2px 9px',
                        backgroundColor: '#121212',
                        color: '#ffffff',
                        borderRadius: '20px',
                      }}>
                        <Typography style={{
                          fontWeight: 400,
                          fontSize: '9px',
                          fontFamily: "OakesGrotesk",
                          letterSpacing: '0.7px',
                        }}>BELI</Typography>
                      </Box>
                    </Box>
                  </Box>
              </Box>
              }
              {/* Flash Sale */}
              
            </div>
          </div>
          {/* Chat ala TikTok */}
        </Grid>
        {/* <Grid item xs={12}>
          <div id='chat-ws-logs' style={{
            height: '80px',
            overflowY: 'scroll',
            backgroundColor: '#f4f4f4',
            padding: '0px 16px 4px',
            color: '#232323',
            borderRadius: '10px',
            border: '1px solid #E0E0E0',
            marginBottom: '7px'
          }}></div>
        </Grid> */}
        <Grid item xs={8}>
          <TextField
          style={{
            marginLeft: '15px',
          }}
            margin="dense"
            fullWidth
            multiline
            id="livestreamChatInput"
            name="livestreamChatInput"
            label="Kirim Chat"
            type="text"
            value={lsKirimText}
            error={false}
            onChange={(e) => {
              setLsKirimText(e.target?.value);
            }}
            InputLabelProps={{
              shrink: true,
            }}/>
        </Grid>
        <Grid item xs={4} style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          borderRadius: '20px',
        }}>
          <Button onClick={() => {
            if (lsKirimText !== '') {
              sendWebsiteEventMessage('[LIVE] Message: ' + lsKirimText);
              dispatch(sendLivestreamMessage(lsKirimText));
            }
            setLsKirimText('');
          }} style={{
            backgroundColor: '#232323',
            color: '#ffffff',
            fontWeight: 400,
            letterSpacing: '0.9px',
            fontSize: '12px',
            padding: '4px 14px 1px 14px',
            borderRadius: '11px',
            marginLeft: '5px',
            marginRight: '10px',
          }}>
            KIRIM
          </Button>
        </Grid>
      </Grid>
    </Dialog>);

}

export interface TailorChatEvent {
  chatUserId: string
  creationDateTime: string
  contentType: "STRING" | "IMAGE" | "INFO"
  content: string
  author: string
}

export function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement<any, any> },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} timeout={170} />;
});


function App() {
  let query = useQuery();
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const currentAccountState = useAppSelector(state => state.account);
  const productsListStatus = useAppSelector(state => state.productsList.status);
  const cartState = useAppSelector(state => state.cart);
  const overlayFlowVersionView = useAppSelector(state => state.overlayFlowVersionView);
  const history = useHistory();
  const location = useLocation();

  // /link is a standalone minimal-chrome landing page with its own WHEP
  // player — keep the storefront's floating livestream widget and shared
  // headless player off it.
  const isLinkPage = location.pathname === '/link';

  const [shopkeeperCustomerData, setShopkeeperCustomerData] = React.useState<any>({});

  // LIVESTREAM STAGE INFO - Used for event and stage stream is on information
  const [latestStageInfo, setLatestStageInfo] = React.useState<any>({});

  // LIVESTREAM
  const streamIsOn = useAppSelector(state => state.livestreamState.streamIsOn);
  const lsDialogSendMessageOpen = useAppSelector(state => state.livestreamState.liveStreamDialogState === 'LIVE');

  const [isConnected, setIsConnected] = React.useState(socket.connected);

  // Applies a livestream state payload ({ streamIsOn, productSpotlightList })
  // from either the REST fetch or the socket's 'livestream:state' push.
  const applyLivestreamState = (stageInfo: any) => {
    if (!stageInfo) return;
    console.log("[LIVESTREAM] STAGE INFO: UPDATING STAGE INFO.");
    setLatestStageInfo(stageInfo); // For in react
    (window as any).livestreamStageInfo = stageInfo; // For event callbacks (state in react is not updated after function creation)

    const streamIsOnNew = !!stageInfo.streamIsOn;
    console.log('SETTING STREAM ON ' + streamIsOnNew)
    dispatch(setStreamIsOn(streamIsOnNew));
    // Window flag rather than component state: this runs from socket
    // handlers registered once on mount, where React state is stale — and
    // state pushes arrive on every dashboard save, not just on/off flips.
    if (streamIsOnNew !== !!(window as any).lsStreamActive) {
      (window as any).lsStreamActive = streamIsOnNew;
      if (streamIsOnNew) {
        sendWebsiteEventMessage('[LIVE] Entering stream.');
        const mixpanelId = Mixpanel.get_distinct_id();
        const customerName = (window as any)?.studio_s_customer_name ?? '';
        dispatch(setSenderObject({ // Second try at setting
          userIdentifier: mixpanelId,
          customerName: customerName,
        }));
        dispatch(sendLivestreamStatus());

        if (!(window.location.href?.includes("shopkeeper-panel"))) {
          dispatch(sendLivestreamMessage("User " + (customerName ? customerName : mixpanelId.substring(15, 20)) + " baru join."));
        };

        // Refresh presence periodically (page URL changes ride along);
        // liveness itself is tracked by the socket connection server-side.
        if (!(window as any).lsStatusInterval) {
          (window as any).lsStatusInterval = setInterval(() => {
            dispatch(sendLivestreamStatus());
          }, 10000);
        }
      } else {
        dispatch(sendLivestreamStatus());
      }
    }

    // Flash-sale spotlights overlay (DialogSendMessageLivestream reads
    // these from CartRedux).
    dispatch(setProductSpotlightList(stageInfo.productSpotlightList ?? []));
  };

  const refreshLivestream = async () => {
    console.log("[LIVESTREAM] FETCHING STREAM DATA.");
    try {
      const response = await terbebasClient.get('/storefront/livestream');
      applyLivestreamState(response.data);
    } catch (e) {
      console.log('[LIVESTREAM] state fetch failed', e);
    }
  };


  useEffect(() => {
    // ADD HISTORY BY DEFAULT IF IN PRODUCT PAGE ALREADY
    if (history.location.pathname.includes('/shop/product')) {
      history.push(history.location.pathname);
    }

    // LIVESTREAM
    refreshLivestream();

    // TAILOR CHAT
    function onConnect() {
      setIsConnected(true);
    }

    function onDisconnect() {
      setIsConnected(false);
    }

    // Livestream chat (terbebas socket protocol): one 'chat:message'
    // broadcast reaches every viewer and the merchant dashboard.
    function onLivestreamChatMessage(message: { content: string; senderName?: string; fromHost?: boolean }) {
      if (!message?.content) return;

      const chatEl = document.createElement("p");
      if (message.content.startsWith("https")) {
        // Product links shared into the chat open inside the app.
        chatEl.textContent = '[Klik Untuk Buka] ' + message.content;
        chatEl.style.cssText = 'font-size: 10px; font-family: OakesGrotesk; font-weight: 300';
        chatEl.onclick = () => {
          dispatch(setLivestreamDialog('MINI'));
          const path = message.content.replace(/^https?:\/\/[^/]+/, '');
          history.push(path || '/');
        }
      } else {
        chatEl.textContent = (message.senderName ?? 'Pengunjung') + ': ' + message.content;
        chatEl.style.cssText = 'font-size: 9.5px; font-family: OakesGrotesk; font-weight: 300; margin: 3px 0px 7px 0px; letter-spacing: 0.6px';
      }

      const chatContainer = document.getElementById('chat-ws-logs');
      if (chatContainer) {
        chatContainer.appendChild(chatEl);
        chatContainer.scrollTop = chatContainer.scrollHeight;
      }
      const chatContainerShop = document.getElementById('chat-ws-logs-shopkeeper');
      if (chatContainerShop) {
        // A node can only live in one container — the shopkeeper log gets
        // a copy (the original had a move-the-node bug here).
        chatContainerShop.appendChild(chatEl.cloneNode(true));
        chatContainerShop.scrollTop = chatContainerShop.scrollHeight;
      }
    }

    // Server push after any dashboard change (ON/OFF air, spotlight save).
    function onLivestreamState(state: any) {
      applyLivestreamState(state);
    }

    socket.on('connect', onConnect);
    socket.on('disconnect', onDisconnect);
    socket.on('chat:message', onLivestreamChatMessage);
    socket.on('livestream:state', onLivestreamState);

    // Get chat history is delayed for 8 s, to allow for others to come in first
    setTimeout(() => {
      // Get chat history
      dispatch(getChatHistory({ chatUserId: "ALL" }));
    }, 8000);

    // SESSION START
    Mixpanel.track('Session start');
    const distinct_id = Mixpanel.get_distinct_id();
    (window as any).hj('identify', distinct_id, {
      'Id Mixpanel': distinct_id
    });

    // Collect up to 40 random Hotjar sessions a day, from current of 600 sessions
    if (Math.random() <= (40 / 600)) 
    {
      // START HOTJAR RECORDING
      (window as any).hj('event', 'start_hotjar_rec');
      (window as any).hj('event', 'event_random_recording_start');
      console.log("START-HOTJAR-REC");
    }

    setUserIdentifier(distinct_id.substring(15, 20));
    dispatch(setSenderObject({
      userIdentifier: distinct_id
    }));
    dispatch(sendLivestreamStatus()); // register name/page in the presence roster

    // We send a notification to SMS that the website is accessed once

    var dariFacebook = window.location.href.indexOf('?fbclid=') !== -1;
    var asalBuka = dariFacebook ? " IG Link " : " URL ";

    if (window.location.href.indexOf("careers") === -1) { // If careers is not found
      const text2 = "[NEW VISIT] dari " + asalBuka + ", mulai dari x" + window.location.href;
      sendWebsiteEventMessage(text2);
    }

    const localStorageFlowVersion = localStorage.getItem("flowVersion");
    if (localStorageFlowVersion !== null) {
      let savedState: FlowVersionState = JSON.parse(localStorageFlowVersion);
      if (savedState) {
        dispatch(loadFlowVersionState(savedState));
      }
    }

    // Unload handler
    const handleLoad = () => {
      const text2 = "[EXIT SITE] User keluar dari web (unload).";
      sendWebsiteEventMessage(text2);
    };
    window.addEventListener('beforeunload', handleLoad);

    const handleWebHide = () => {
      if (document.visibilityState === 'hidden') {
        const text2 = "[EXIT SITE] User keluar dari web (hide).";
        sendWebsiteEventMessage(text2);
      } else if (document.visibilityState === 'visible') {
        const text2 = "[REVISIT SITE] User masuk lagi ke web.";
        sendWebsiteEventMessage(text2);
      }
    };
    document.addEventListener('visibilitychange', handleWebHide);

    return () => {
      socket.off('connect', onConnect);
      socket.off('disconnect', onDisconnect);
      socket.off('chat:message', onLivestreamChatMessage);
      socket.off('livestream:state', onLivestreamState);
      window.removeEventListener('beforeunload', handleLoad);
      document.removeEventListener('visibilitychange', handleWebHide);
    };

  }, []);

  useEffect(() => {
    const collectionQueryKeyValue = query.get("collectionkey");
    if (collectionQueryKeyValue) {
      dispatch(setCollectionQueryKey(collectionQueryKeyValue));
    }
    const sortQueryKeyValue = query.get("sortkey");
    if (sortQueryKeyValue) {
      dispatch(setSortQueryKey(sortQueryKeyValue));
    }
    const couponQueryKeyValue = query.get("couponkey");
    if (couponQueryKeyValue) {
      dispatch(submitCouponRequest(couponQueryKeyValue));
    } else if (cartState.couponKey) {
      // Re-validate a coupon restored from localStorage: it may have expired,
      // been exhausted, or (once signed in) hit its per-account limit. The
      // reducer drops it if it's no longer usable.
      dispatch(submitCouponRequest(cartState.couponKey));
    }

    const queryFlowVersionValue = query.get("flowversion");
    if (queryFlowVersionValue !== null && queryFlowVersionValue !== ""
      && (queryFlowVersionValue === "softintro1" || queryFlowVersionValue === "hardintro1" || queryFlowVersionValue === "plusintro1")) {
      const pathName = (window as any).location.pathname;

      // PLUS SIZE OVERRIDE
      if (pathName && pathName.includes("plus")) {
        dispatch(setFlowVersion("plusintro1"));
        history.push(pathName); // Added such that when navbar back is pressed, it doesn't go to current path
        return;
      }

      dispatch(setFlowVersion(queryFlowVersionValue));
      sendWebsiteEventMessage("User masuk ke flow version " + queryFlowVersionValue);

      if (pathName) {
        history.push(pathName); // Added such that when navbar back is pressed, it doesn't go to current path
      }
    }

    // Set FB Click ID links to be softintro1 by default
    const queryFlowVersionValueFbc = query.get("fbclid");
    if (queryFlowVersionValueFbc !== null && queryFlowVersionValueFbc !== "" && queryFlowVersionValueFbc.length > 0) {

      const pathName = (window as any).location.pathname;

      // PLUS SIZE OVERRIDE
      if (pathName && pathName.includes("plus")) {
        dispatch(setFlowVersion("plusintro1"));
        sendWebsiteEventMessage("User masuk ke flow version " + "plusintro1");
        history.push(pathName); // Added such that when navbar back is pressed, it doesn't go to current path
        return;
      }

      if (pathName && pathName.startsWith("/shop/category/")) {
        dispatch(setFlowVersion("softintro1"));
        sendWebsiteEventMessage("User masuk ke flow version " + "softintro1");
        history.push(pathName); // Added such that when navbar back is pressed, it doesn't go to current path
      }
    }
  }, [query]);

  // Set distinct ID if there is none
  if (currentAccountState.distinctUserId === '') {
    if (localStorage.getItem("distinctUserId") === null) {
      console.log("Setting new user ID " + new Date().toISOString());
      const newDistinctUserId = 'DUID-' + new Date().toISOString();
      dispatch(updateState({
        distinctUserId: newDistinctUserId
      }));
      localStorage.setItem("distinctUserId", newDistinctUserId);
    }
  }

  // We fetch when starting or when signed in but token already expired
  const fetchAuthStateFromLocalStorage = currentAccountState.authState === 'starting'
    || (currentAccountState.authState === 'signedin' && (currentAccountState.tokenExpiration && Date.now() >= parseInt(currentAccountState.tokenExpiration) * 1000));
  if (fetchAuthStateFromLocalStorage) {

    console.log("Attempting fetch auth state from local storage");
    console.log(JSON.stringify(currentAccountState, null, 2));

    const localStorageAccount = localStorage.getItem("account");
    if (localStorageAccount) {
      let savedState: AccountState = JSON.parse(localStorageAccount);
      if (savedState &&
        savedState.authState === 'signedin' &&
        savedState.tokenExpiration && 
        Date.now() < parseInt(savedState.tokenExpiration) * 1000) {

        dispatch(updateState({
          ...savedState,
          chatUserId: savedState.chatUserId ? savedState.chatUserId : 'USER-' + Math.floor(Math.random() * 100000),
          statusSignIn: APIRequestStatus.Idle,
          signInError: '',
          statusSignUp: APIRequestStatus.Idle,
          signUpError: '',
        }));

        (window as any).studio_s_customer_name = savedState.name;
        dispatch(setSenderObject({
          customerName: savedState.name,
        }));

        dispatch(fetchOrdersList());
        dispatch(fetchAddresses());
      } else {
        console.log("Local storage found, but invalid.");
        dispatch(updateState({
          chatUserId: 'USER-' + Math.floor(Math.random() * 100000),
          authState: 'signedout',
          statusSignIn: APIRequestStatus.Idle,
          signInError: '',
          statusSignUp: APIRequestStatus.Idle,
          signUpError: '',
        }));
        dispatch(openOverlayGeneralIntro());
      }
    } else {
      console.log("No local storage found.");
      dispatch(updateState({
        chatUserId: 'USER-' + Math.floor(Math.random() * 100000),
        authState: 'signedout',
        statusSignIn: APIRequestStatus.Idle,
        signInError: '',
        statusSignUp: APIRequestStatus.Idle,
        signUpError: '',
      }));
      dispatch(openOverlayGeneralIntro());
    }
  }

  // We check availability of items in cart if there is items, but the hash is empty / not checked
  if (cartState.cartProductList.length !== 0 && cartState.cartProductListHash === '') {
    console.log("Checking current cookie cart items availability");
    dispatch(postCheckCurrentCartAvailability({}));
  }

  if (productsListStatus === APIRequestStatus.Idle) {
    console.log("start fetch");
    dispatch(fetchProductsList({}));
    dispatch(fetchStoreProfile());
    dispatch(fetchCategoryReviewRecap(''));
  }

  const isInsideIframe = window.self !== window.top;

  // if (window.location.href.includes('offline-live')) {
  //   return (
  //     <div style={{
  //       backgroundColor: '#fff',

  //       rotate:'-90deg',
  //       position:'fixed',
  //       // top:0,
  //       left:0,
  //       bottom:0,
  //       right:0,
  //       width:'100vh', 
  //       height:'100vw',
  //       border:'none',
  //       margin:0,
  //       padding:0,
  //       overflow:'hidden',
  //       zIndex:999999,

  //       top: '100vh',
  //       transformOrigin: 'top left',
  //     }}>
  //     <iframe
  //       src="/shop"
  //       style={{width: '100%', height: '100%'}}
  //       title="live-offline"/>
  //     </div>
  //   );
  // }

  return (
      <ThemeProvider theme={theme}>
        <div className={classes.contentRoot}>
          <FloatingLiveStream isOpen={streamIsOn && !lsDialogSendMessageOpen && !isLinkPage} openSendMessage={() => dispatch(setLivestreamDialog('LIVE'))} stageInfo={latestStageInfo}/>
          <DialogSendMessageLivestream isOpen={streamIsOn && lsDialogSendMessageOpen && !isLinkPage} setLsDialogSendMessageOpen={(nextState: boolean) => dispatch(setLivestreamDialog(nextState ? 'LIVE' : 'MINI'))} lsParticipantId={'string'} stageInfo={latestStageInfo}/>
          <ScrollToTopComponent />
          <AnalyticsRouteTracker />
          <Switch>
            <Route path="/plus-size">
              <Redirect to={"/shop/category/plus-size"}/>
            </Route>
            <Route path="/plus">
              <Redirect to={"/shop/category/plus-size"}/>
            </Route>
            <Route path="/staging-area">
            
            </Route>            
            <Route path="/shop">
              <NavBar transparentAtTop={false} transparent={true} coloredAtTop={false} largerTitleAtTop={false} />
              <BannerOngkir hideView={true}/>
              <Toolbar />
              <PageProduct />
            </Route>
            <Route path="/your-account">
              <NavBar transparentAtTop={true} transparent={true} coloredAtTop={false} largerTitleAtTop={false} />
              <Toolbar />
              <Toolbar />
              <PageAccount />
            </Route>
            <Route path="/checkout">
              <PageCheckout />
            </Route>
            <Route path="/order/:orderId">
              <PageOrderCommerce />
            </Route>
            <Route path="/pages/:pageHandle">
              <PageCustomCommerce />
            </Route>
            <Route path="/preview-blocks">
              <PagePreviewBlocks />
            </Route>
            <Route path="/link">
              <PageLinkPage />
            </Route>
            <Route path="/shopkeeper-panel-3800128bafb3b3881jsa08f8181ja">
              <PageShopkeeperPanel shopkeeperCustomerData={shopkeeperCustomerData} isConnected={isConnected} />
            </Route>
            <Route path="/">
              <PageHomeCommerce />
            </Route>
          </Switch>
          <Switch>
            <Route path="/shopkeeper-panel-3800128bafb3b3881jsa08f8181ja">
            </Route>
            <Route path="/link">
            </Route>
            {!isInsideIframe &&
              <Route>
                <PageHomeFooter />
              </Route>
            }
          </Switch>
          <Switch>
            <Route path="/shop">
              <Bantuan useTailor={false} hideBantuan={false} />
            </Route>
            <Route path="/order">
              <Bantuan useTailor={false} hideBantuan={false} />
            </Route>
            <Route>
            </Route>
          </Switch>
          <Switch>
            <Route path="/shop">
              <PromoFloat />
            </Route>
            <Route>
            </Route>
          </Switch>
          <OverlayViewAccount />
          <OverlayViewMeasurementMethodSelection />
          <OverlayViewMeasurementSelection />
          <OverlayViewAddress />
          <OverlayViewPopupFlowVersion />
          <OverlayViewPopupOngkir />
          <OverlayViewPopupLivestreamIntro />
          { streamIsOn && !isLinkPage && <LiveStream url={ streamIsOn ? `${SRS_HTTP_URL}/rtc/v1/whep/?app=live&stream=${TERBEBAS_STORE_SLUG}` : ''}/> }
          <IframeMessageBridge /> 
        </div>
      </ThemeProvider>
  );
}

const dummyProductSpotlightList = [
  {
    productId: '2023-10-KnitTeeCollection-WaffleTeeBrown',
    discountedPrice: 110000,
    timestampLimit: '2024-07-01T12:00:00.000Z',
    isMainSpotlight: false
  },
  {
    productId: '2024-03-KokoCollection-RayaSloperinMidtoneGrey',
    discountedPrice: 100000,
    timestampLimit: '2024-07-01T12:00:00.000Z',
    isMainSpotlight: false
  },
]

export default App;
